import tabClasses from "@mui/material/Tab/tabClasses";
import tabsClasses from "@mui/material/Tabs/tabsClasses";
import { typographyResponsive } from "../../styles/utils/typography.module";
import { getHighestSpreadRadiusinPxFromBoxShadow } from "../../styles/utils/utils";
export const MuiTabTheme = (dt) => {
    const shadowSize = getHighestSpreadRadiusinPxFromBoxShadow(dt.state.focus.primary);
    return {
        defaultProps: {
            disableRipple: true,
            disableTouchRipple: true,
        },
        styleOverrides: {
            root: Object.assign(Object.assign({}, typographyResponsive(dt, "body1.regular")), { position: "relative", rowGap: dt.inline.xSmall, columnGap: dt.inline.small, minWidth: "auto", minHeight: "auto", ".PixelIcon": {
                    margin: 0,
                    width: dt.icon.size.large,
                    height: dt.icon.size.large,
                    '&:not([class*="MuiSvgIcon-color"])': {
                        backgroundColor: dt.color.onSurface.variant,
                        color: dt.color.onSurface.variant,
                    },
                }, "&::after": {
                    display: "block",
                    position: "absolute",
                    content: '""',
                    overflow: "hidden",
                }, ".Pxl-tabs-pxlVariant-main &": {
                    padding: `${dt.inset.squish.medium.vertical} ${dt.inset.squish.medium.horizontal}`,
                    "&:hover, &.pxl-demo-hover": {
                        backgroundColor: dt.cta.outlined.color.background.primary.hover,
                    },
                    "&:focus-visible, &.pxl-demo-focus": {
                        "::before": {
                            display: "block",
                            position: "absolute",
                            content: '""',
                            top: `${shadowSize * 2}px`,
                            right: `${shadowSize * 2}px`,
                            bottom: `${shadowSize * 2}px`,
                            left: `${shadowSize * 2}px`,
                            boxShadow: dt.state.focus.primary,
                            borderRadius: dt.button.shape.borderRadius,
                        },
                    },
                    "&:active, &.pxl-demo-active": {
                        backgroundColor: dt.cta.outlined.color.background.primary.pressed,
                    },
                    [`&.${tabClasses.selected}`]: Object.assign(Object.assign({}, typographyResponsive(dt, "body1.bold")), { color: dt.color.primary.key, ".PixelIcon": {
                            backgroundColor: dt.color.primary.key,
                        } }),
                }, [`.Pxl-tabs-pxlVariant-main.${tabsClasses.vertical} &`]: {
                    rowGap: 0,
                    padding: `${dt.space.stack.xSmall2} ${dt.inset.squish.medium.variant.horizontal}`,
                }, ".Pxl-tabs-pxlVariant-sub &": {
                    ".PixelIcon": {
                        width: dt.icon.size.medium,
                        height: dt.icon.size.medium,
                    },
                    "&:hover, &.pxl-demo-hover": {
                        color: dt.color.onSurface.key,
                        "&::after": {
                            opacity: dt.opacity.states.disabled.content,
                            backgroundColor: dt.color.onSurface.variant,
                        },
                    },
                    "&:focus-visible, &.pxl-demo-focus": {
                        "&::before": {
                            display: "block",
                            position: "absolute",
                            content: '""',
                            top: `${shadowSize}px`,
                            right: `${shadowSize}px`,
                            bottom: `${shadowSize}px`,
                            left: `${shadowSize}px`,
                            boxShadow: dt.state.focus.primary,
                            borderRadius: dt.button.shape.borderRadius,
                        },
                    },
                    "&:active, &.pxl-demo-active": {
                        color: dt.color.onSurface.key,
                        "&::after": {
                            opacity: dt.opacity.states.disabled.content,
                            backgroundColor: dt.cta.outlined.color.border.primary.default,
                        },
                    },
                    [`&.${tabClasses.selected}`]: Object.assign(Object.assign({}, typographyResponsive(dt, "body1.medium")), { color: dt.color.onSurface.key, ".PixelIcon": {
                            backgroundColor: dt.color.primary.key,
                        } }),
                }, [`.Pxl-tabs-pxlVariant-sub:not(.${tabsClasses.vertical}) &`]: {
                    padding: `${shadowSize}px ${shadowSize}px ${shadowSize * 2}px ${shadowSize}px`,
                    "&::before": {
                        bottom: `${shadowSize * 2}px`,
                    },
                    "&::after": {
                        display: "block",
                        position: "absolute",
                        content: '""',
                        overflow: "hidden",
                    },
                    ".Pxl-tabs-pxlVariant-main &": {
                        padding: `${dt.inset.squish.medium.vertical} ${dt.inset.squish.medium.horizontal}`,
                        "&:hover, &.pxl-demo-hover": {
                            backgroundColor: dt.cta.outlined.color.background.primary.hover,
                        },
                        "&:focus-visible, &.pxl-demo-focus": {
                            "::before": {
                                display: "block",
                                position: "absolute",
                                content: '""',
                                top: `${shadowSize * 2}px`,
                                right: `${shadowSize * 2}px`,
                                bottom: `${shadowSize * 2}px`,
                                left: `${shadowSize * 2}px`,
                                boxShadow: dt.state.focus.primary,
                                borderRadius: dt.button.shape.borderRadius,
                            },
                        },
                        "&:active, &.pxl-demo-active": {
                            backgroundColor: dt.cta.outlined.color.background.primary.pressed,
                        },
                        [`&.${tabClasses.selected}`]: Object.assign(Object.assign({}, typographyResponsive(dt, "body1.bold")), { color: dt.color.primary.key, ".PixelIcon": {
                                backgroundColor: dt.color.primary.key,
                            } }),
                    },
                    [`.Pxl-tabs-pxlVariant-main.${tabsClasses.vertical} &`]: {
                        rowGap: 0,
                        padding: `${dt.space.stack.xSmall2} ${dt.inset.squish.medium.variant.horizontal}`,
                    },
                    ".Pxl-tabs-pxlVariant-sub &": {
                        ".PixelIcon": {
                            width: dt.icon.size.medium,
                            height: dt.icon.size.medium,
                        },
                        "&:hover, &.pxl-demo-hover": {
                            color: dt.color.onSurface.key,
                            "&::after": {
                                opacity: dt.opacity.states.disabled.content,
                                backgroundColor: dt.color.onSurface.variant,
                            },
                        },
                        "&:focus-visible, &.pxl-demo-focus": {
                            "&::before": {
                                display: "block",
                                position: "absolute",
                                content: '""',
                                top: `${shadowSize}px`,
                                right: `${shadowSize}px`,
                                bottom: `${shadowSize}px`,
                                left: `${shadowSize}px`,
                                boxShadow: dt.state.focus.primary,
                                borderRadius: dt.button.shape.borderRadius,
                            },
                        },
                        "&:active, &.pxl-demo-active": {
                            color: dt.color.onSurface.key,
                            "&::after": {
                                opacity: dt.opacity.states.disabled.content,
                                backgroundColor: dt.cta.outlined.color.border.primary.default,
                            },
                        },
                        [`&.${tabClasses.selected}`]: Object.assign(Object.assign({}, typographyResponsive(dt, "body1.medium")), { color: dt.color.onSurface.key, ".PixelIcon": {
                                backgroundColor: dt.color.primary.key,
                            } }),
                    },
                    [`.Pxl-tabs-pxlVariant-sub:not(.${tabsClasses.vertical}) &`]: {
                        padding: `${shadowSize}px ${shadowSize}px ${shadowSize * 2}px ${shadowSize}px`,
                        "&::before": {
                            bottom: `${shadowSize * 2}px`,
                        },
                        "&::after": {
                            right: 0,
                            bottom: 0,
                            left: 0,
                            height: dt.size.xSmall4,
                        },
                    },
                    [`.Pxl-tabs-pxlVariant-sub.${tabsClasses.vertical} &`]: {
                        padding: `${dt.inset.squish.medium.variant.vertical} ${dt.inset.squish.medium.variant.horizontal} ${dt.inset.squish.medium.variant.vertical} ${dt.inset.squish.medium.variant.horizontal}`,
                        justifyContent: "flex-start",
                        "&::before": {
                            right: `${shadowSize * 2}px`,
                        },
                        "&::after": {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            width: dt.size.xSmall4,
                        },
                    },
                    [`.Pxl-tabs-altIndicatorPosition.Pxl-tabs-pxlVariant-sub:not(.${tabsClasses.vertical}) &::after`]: {
                        top: 0,
                        bottom: "unset",
                    },
                    [`.Pxl-tabs-altIndicatorPosition.Pxl-tabs-pxlVariant-sub.${tabsClasses.vertical} &::after`]: {
                        right: "unset",
                        left: 0,
                        height: dt.size.xSmall4,
                    },
                }, [`.Pxl-tabs-pxlVariant-sub.${tabsClasses.vertical} &`]: {
                    padding: `${dt.inset.squish.medium.variant.vertical} ${dt.inset.squish.medium.variant.horizontal} ${dt.inset.squish.medium.variant.vertical} ${dt.inset.squish.medium.variant.horizontal}`,
                    justifyContent: "flex-start",
                    "&::before": {
                        right: `${shadowSize * 2}px`,
                    },
                    "&::after": {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        width: dt.size.xSmall4,
                    },
                }, [`.Pxl-tabs-altIndicatorPosition.Pxl-tabs-pxlVariant-sub:not(.${tabsClasses.vertical}) &::after`]: {
                    top: 0,
                    bottom: "unset",
                }, [`.Pxl-tabs-altIndicatorPosition.Pxl-tabs-pxlVariant-sub.${tabsClasses.vertical} &::after`]: {
                    right: "unset",
                    left: 0,
                }, "&:disabled": {
                    color: dt.cta.contained.color.text.primary.disabled,
                    ".PixelIcon": {
                        backgroundColor: dt.cta.contained.color.text.primary.disabled,
                    },
                }, "&.Pxl-tab-iconPosition-start": {
                    padding: `${dt.inset.squish.medium.variant.vertical} 0`,
                } }),
        },
    };
};
